import React from 'react'
import SpinGif from '../../../assets/Gifs/spin.gif'

function ObjectHome () {
  return (
    <div className='HomeCanvas' data-testid='home-canvas'>
      <img className='HomeCanvas__Spin' src={SpinGif} alt='spin-gif' />
    </div>
  )
}

export default ObjectHome
